import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLoaderComponent } from './my-loader.component';

@NgModule({
  declarations: [
    MyLoaderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MyLoaderComponent
  ]
})
export class MyLoaderModule { }
